var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpandIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hsi2grr00a",
    x1: "-42.375%",
    x2: "148.921%",
    y1: "175.601%",
    y2: "-133.375%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EA6AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.678%",
    stopColor: "#196BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7DFF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6ftj7aidjb",
    x1: "172.116%",
    x2: "211.106%",
    y1: "171.427%",
    y2: "-73.763%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EA6AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.316%",
    stopColor: "#0057A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7DFF7A"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hsi2grr00a)",
    d: "M0 .8v14.4c0 .442.358.8.8.8h14.4c.442 0 .8-.358.8-.8V.8c0-.442-.358-.8-.8-.8H.8C.358 0 0 .358 0 .8zm1.333 13.067V2.213c0-.486.394-.88.88-.88h11.654c.442 0 .8.359.8.8v11.734c0 .441-.358.8-.8.8H2.133c-.441 0-.8-.359-.8-.8z",
    transform: "translate(-992 -1036) translate(992 1036)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hsi2grr00a)",
    d: "M9.333 4h1.724L8.862 6.195c-.26.26-.26.683 0 .943.26.26.682.26.943 0L12 4.943v1.724c0 .368.298.666.667.666.368 0 .666-.298.666-.666V3.333c0-.022 0-.044-.003-.065l-.004-.03-.006-.035-.008-.033-.007-.03-.012-.032-.01-.03-.014-.029-.014-.03-.016-.027-.018-.029-.021-.028-.018-.024c-.014-.017-.028-.033-.044-.049-.016-.016-.032-.03-.049-.044l-.024-.018-.028-.021-.03-.018-.026-.016-.03-.014-.03-.014-.029-.01-.032-.012-.03-.007-.033-.008-.035-.006-.03-.004c-.021-.002-.043-.003-.065-.003H9.333c-.368 0-.666.298-.666.666 0 .369.298.667.666.667z",
    transform: "translate(-992 -1036) translate(992 1036)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#6ftj7aidjb)",
    d: "M2.67 12.732l.004.03.006.035.008.033.007.03.012.032.01.03.014.029.014.03.016.027.018.029.021.028.018.024c.014.017.028.033.044.049.016.016.032.03.049.044l.024.018.028.021.03.018.026.015.03.015c.01.005.02.01.03.013.01.005.02.008.03.011l.03.011.031.008.033.008.035.006.03.004c.021.002.043.003.065.003h3.334c.368 0 .666-.298.666-.666 0-.369-.298-.667-.666-.667H4.943l2.195-2.195c.26-.26.26-.683 0-.943-.26-.26-.682-.26-.943 0L4 11.057V9.333c0-.368-.298-.666-.667-.666-.368 0-.666.298-.666.666v3.334c0 .022 0 .044.003.065z",
    transform: "translate(-992 -1036) translate(992 1036)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expandIcon.88279f5ed28b222874985eb86635df38.svg";
export { ForwardRef as ReactComponent };